'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.load = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _littleLoader = require('little-loader');

var _littleLoader2 = _interopRequireDefault(_littleLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var load = exports.load = function load(script) {
    return (
        // eslint-disable-next-line no-confusing-arrow
        new _promise2.default(function (resolve, reject) {
            return (0, _littleLoader2.default)(script, function (err) {
                return err ? reject(err) : resolve();
            });
        })
    );
};
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/pulse/loaders/util.js
 ** module id = 296
 ** module chunks = 1
 **/